import { _ } from "../../core/polyglot/polyglot.js";
import Period from "./Period.js";

/**
 * `halfYear` is a period representing half a year.
 * Instances should not be created by hand, but rather looked up
 * from `fiscalYear`.
 *
 * @param {{}} spec - Parameter object
 * @param {{}} my - protected fields holder
 * @return {*} halfYear
 */
export default class HalfYear extends Period {
	constructor(spec) {
		super(spec);
		this._name = _("H{index}", { index: this.getPeriodIndex() });
		this._periodId = `H${this.getPeriodIndex()}`;
	}

	isHalfYear() {
		return true;
	}

	getGroupLabel() {
		return _("Year");
	}

	static getType() {
		return "HalfYear";
	}
}
